import { HistoricalYieldFees } from './HistoricalYieldFees.entity';

export class YieldFeesChart {
  constructor(
    public totalYield: number,
    public totalFees: number,
    public totalRevenue: number,
    public historical: HistoricalYieldFees[]
  ) {}
}
